<template>
  <div class="w-full h-full flex justify-center items-center">
    <div class="login mx-auto p-8">
      <div class="bg-white">
        <img src="../assets/media/classen_logo.jpg">
        <p class="text-red-500 font-bold" v-if="$route.query.data">{{$route.query.data}}</p>
        <p class="text-red-600" v-if="error">Wrong credentials</p>
        <p v-if="statusMessage" class="text-red-600 cursor-pointer" @click="onClickForgotPassword"
           v-html="statusMessage"></p>
        <form class="grid gap-2" @keydown.enter.prevent="onClickLoginUser()"
              @submit.prevent="onClickLoginUser()">

          <span class="justify-self-start self-end">Email</span>
          <input type="email" id="email" class="h-45px bg-classen__secondary"
                 v-model="email" required>

          <label class="justify-self-start self-end">Password</label>
          <input type="password" id="password" class="h-45px bg-classen__secondary"
                 v-model="password" autocomplete="off"
                 required>

          <label class="justify-self-end underline" @click="onClickForgotPassword"><a
            href="#">Forgot
            password</a></label>

          <button type="submit"
                  class="bg-classen__primary mt-4 classen__button flex items-center justify-center justify-self-center"
                  :class="{'btn--disabled':!loginValid}">
            <p class="m-0">Login</p>
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from './Loader';

export default {
  name: 'Login',

  components: {
    'c-loader': Loader,
  },

  data() {
    return {
      email: null,
      password: null,

      error: false,

      saveLogin: false,
      isLoggingIn: false,

      statusMessage: null,
    }
  },

  created() {
    document.title = 'The Qube - Login';
  },

  computed: {
    loginValid() {
      return this.email && this.password;
    }
  },

  methods: {
    onClickForgotPassword() {
      window.open(`${process.env.VUE_APP_SERVICEURL}forgot-password`)
    },

    onClickLoginUser() {
      const userObj = {email: this.email, password: this.password};
      Promise.all([this.loginUser(userObj)])
        .then((response) => {
          const authUser = response[0];
          if (authUser.needsToChangePassword) {
            this.statusMessage = "We noticed you didn't change your password in the last year. <strong> Please request a new one. </strong>"
          } else {
            window.localStorage.setItem(process.env.VUE_APP_LOCALSTORAGETAG, JSON.stringify(authUser));
            this.setLoggedInProperty(authUser);
          }
        })
        .catch((response) => {
          this.statusMessage = "Wrong credentials"
        });
    },

    loginUser(userCredentials) {
      return new Promise((resolve, reject) => {
        this.$dashboardStore.dispatch('loginUser', userCredentials)
          .then((authorizedUser) => {
            resolve(authorizedUser);
          })
          .catch((error) => {
            console.warn('Something went wrong logging in', error);
            reject()
          });
      });
    },

    setLoggedInProperty(authUser) {
      this.$dashboardStore.dispatch('setLoggedInAtProperty')
        .then(() => {
          this.$dashboardStore.dispatch('getTranslations');
          this.$dashboardStore.dispatch('setUserObject', authUser);
          this.$router.push({path: '/products'});
        })
        .catch((error) => {
          console.warn('Something went wrong setting the last login property', error)
        });
    }
  }
};
</script>
<style scoped>
form {
  grid-template-rows: repeat(4, 45px) 5px 60px;
}

.login {
  width: 700px;
}

.classen__button {
  color: white;
}
</style>
